import React from "react";
import "./projects.css";

const Menu = ({ projectList }) => {
	return (
		<section className="projects__container">
			<div className="projects__container container grid">
				{projectList.map((project) => {
					const { id, title, category, technologies, img, desc, link } =
						project;
					return (
						<div>
							<h4 className="project__title">{title}</h4>
							<div className="projects__content textWithBlurredBg" key={id}>
								<a href={link} target="_blank">
									Source code
								</a>
								<img className="project__img" src={img} alt="" />
								<h5 className="project__desc">{desc}</h5>
							</div>
						</div>
					);
				})}
			</div>
		</section>
	);
};

export default Menu;
